import { gql } from '@apollo/client';
import { ErrorMessageInfo, ReferralInfoShared } from '../fragments';

export default gql`
  mutation updateReferral($input: ReferralUpdateInput!) {
    updateReferral(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      referral {
        ...ReferralInfoShared
      }
    }
  }
  ${ReferralInfoShared}
  ${ErrorMessageInfo}
`;
